/**
 * Centralised date / time formatting for the SPA. Every call site that needs
 * a "dd/mm/yyyy" or "dd/mm/yyyy, hh:mm" string goes through here so the locale
 * can be swapped in one place — including, eventually, honouring a per-user
 * preference once the SPA exposes one.
 *
 * Pinned to <b>en-GB</b> because the template's primary market is UK SMEs, and
 * the browser default — what <c>toLocaleString()</c> with no args resolves to
 * — is too often <c>en-US</c> on Windows machines whose users have actually
 * set their region to United Kingdom. That mismatch is the bug this module
 * fixes (ADO Bug #15).
 *
 * <p>The <c>LogsPage</c> intentionally uses a different ISO-style format
 * ("yyyy-MM-dd hh:mm:ss") so its log timestamps line up vertically and sort
 * lexically — it doesn't go through here.</p>
 */
const Locale = 'en-GB';

const dateTimeFmt = new Intl.DateTimeFormat(Locale, {
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit',
});

const dateFmt = new Intl.DateTimeFormat(Locale, {
  year: 'numeric', month: '2-digit', day: '2-digit',
});

/** "dd/mm/yyyy, hh:mm". Empty string for null/undefined/empty input. */
export function formatDateTime(value: string | Date | null | undefined): string {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? '' : dateTimeFmt.format(d);
}

/** "dd/mm/yyyy". Empty string for null/undefined/empty input. */
export function formatDate(value: string | Date | null | undefined): string {
  if (!value) return '';
  const d = value instanceof Date ? value : new Date(value);
  return Number.isNaN(d.getTime()) ? '' : dateFmt.format(d);
}
